var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Iran(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f44336",
    d: "M42.325,32H5.675C8.763,39.061,15.801,44,24,44S39.237,39.061,42.325,32z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M44,24c0-2.846-0.604-5.549-1.675-8H5.675C4.604,18.451,4,21.154,4,24s0.604,5.549,1.675,8h36.649 C43.396,29.549,44,26.846,44,24z M22.312,17.547C23.135,19.016,24,17.828,24,17.828s0.865,1.188,1.687-0.281 c0.469,0.974-0.896,1.859-1.687,0.969C23.208,19.406,21.844,18.521,22.312,17.547z M21.198,18.51c0,0-4.979,3.891-1.318,9.49 C16.432,25.891,16.13,20.099,21.198,18.51z M24.573,29.896L24,30.641l-0.573-0.74c0,0-1.339,0.443-3.104-0.172 c1.448,0,2.255-0.255,2.552-0.406c0,0-3.276-1.771-3.214-5.365c0.193-3.635,2.13-4.745,2.13-4.745s-3.448,5.021,1.615,9.219 l-0.219-5.193v-3.813C23.474,19.359,24,18.755,24,18.755s0.526,0.604,0.812,0.672v3.813l-0.224,5.193 c5.068-4.193,1.62-9.219,1.62-9.219s1.938,1.104,2.13,4.75c0.063,3.594-3.214,5.359-3.214,5.359 c0.297,0.151,1.104,0.411,2.552,0.411C25.911,30.349,24.573,29.896,24.573,29.896z M28.125,28c3.656-5.599-1.318-9.49-1.318-9.49 C31.87,20.099,31.568,25.891,28.125,28z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4caf50",
    d: "M24,4C15.801,4,8.763,8.939,5.675,16h36.649C39.237,8.939,32.199,4,24,4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#d32f2f",
    d: "M26.569,18.882c0,0,4.553,3.561,1.206,8.686C30.927,25.638,31.203,20.336,26.569,18.882z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#d32f2f",
    d: "M23.999,18.887c0.725,0.815,1.974,0.005,1.545-0.887c-0.753,1.344-1.545,0.257-1.545,0.257 S23.208,19.344,22.455,18C22.026,18.892,23.275,19.702,23.999,18.887z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#d32f2f",
    d: "M27.971,23.874c-0.176-3.337-1.95-4.348-1.95-4.348s3.156,4.601-1.483,8.439l0.205-4.753v-3.49 c-0.262-0.062-0.744-0.615-0.744-0.615s-0.482,0.553-0.744,0.615v3.49l0.2,4.753c-4.634-3.843-1.478-8.439-1.478-8.439 s-1.774,1.015-1.95,4.343c-0.057,3.29,2.942,4.911,2.942,4.911c-0.272,0.138-1.011,0.372-2.336,0.372 c1.616,0.563,2.841,0.157,2.841,0.157l0.524,0.677l0.524-0.682c0,0,1.225,0.415,2.841-0.148c-1.325,0-2.064-0.238-2.336-0.377 C25.029,28.779,28.028,27.163,27.971,23.874z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#d32f2f",
    d: "M21.434,18.882c-4.639,1.454-4.362,6.756-1.206,8.686C16.877,22.443,21.434,18.882,21.434,18.882z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Iran);
export default __webpack_public_path__ + "static/media/icons8-iran.f6adc947c421bd94642011518107d4b4.svg";
export { ForwardRef as ReactComponent };